<button mat-icon-button [matMenuTriggerFor]="actionMenu">
  <mat-icon>more_vert</mat-icon>
</button>

<mat-menu #actionMenu="matMenu">
  <button
    mat-menu-item
    (click)="openDeleteDialog(params.data)"
    [disabled]="!params.data.revoked && !isExpired(params.data.expiresAt)"
  >
    <mat-icon>delete</mat-icon>
    <span>Eliminar</span>
  </button>

  <button
    mat-menu-item
    (click)="openRevokeDialog(params.data)"
    [disabled]="params.data.revoked"
  >
    <mat-icon>block</mat-icon>
    <span>Revocar</span>
  </button>
</mat-menu>

<ng-template #deleteDialog let-data>
  <div class="flex items-start space-x-2 mb-4">
    <div class="flex items-center">
      <mat-icon color="warn" class="ml-4 mt-6" style="font-size: 32px;">warning</mat-icon>
    </div>
    <div class="grid">
      <h2 mat-dialog-title class="text-lg font-bold mb-1">Confirmar eliminación</h2>
      <mat-dialog-content class="modal-content mt-0">
        <p>¿Está seguro que desea eliminar la contraseña de <strong>{{ data?.targetUser.username || '' }}</strong>?</p>
      </mat-dialog-content>
    </div>
  </div>
  <mat-dialog-actions class="modal-actions flex justify-end">
    <button mat-button mat-dialog-close>Conservar</button>
    <button mat-raised-button color="warn" [mat-dialog-close]="true">Eliminar</button>
  </mat-dialog-actions>
</ng-template>

<ng-template #revokeDialog let-data>
  <div class="flex items-start space-x-2 mb-4">
    <div class="flex items-center">
      <mat-icon color="primary" class="ml-4 mt-6" style="font-size: 32px;">block</mat-icon>
    </div>
    <div class="grid">
      <h2 mat-dialog-title class="text-lg font-bold mb-1">Confirmar revocación</h2>
      <mat-dialog-content class="modal-content mt-0">
        <p>¿Está seguro que desea revocar la contraseña de <strong>{{ data?.targetUser.username || '' }}</strong>?</p>
      </mat-dialog-content>
    </div>
  </div>
  <mat-dialog-actions class="modal-actions flex justify-end">
    <button mat-button mat-dialog-close>Cancelar</button>
    <button mat-raised-button color="primary" [mat-dialog-close]="true">Revocar</button>
  </mat-dialog-actions>
</ng-template>